import { render, staticRenderFns } from "./regisMitra.vue?vue&type=template&id=2ae49182"
import script from "./regisMitra.vue?vue&type=script&lang=js"
export * from "./regisMitra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QItemSection,QMenu,QList,QItem,QPagination,QDialog,QSelect,QCardActions,QAvatar,QIcon,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QItemSection,QMenu,QList,QItem,QPagination,QDialog,QSelect,QCardActions,QAvatar,QIcon})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
